/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import axios from "@/axios.js"

const actions = {
    limparListaVeiculos({ commit, state }) {
      commit('LIMPAR_LISTA_VEICULOS', state);
    },
    fetchVeiculos({ commit, state }) {
      return new Promise((resolve, reject) => {
        const params = new URLSearchParams();
        params.append('outputFormat', 'JSON');
        params.append('idCliente', state.AppActiveUser.id);
        params.append('idEmpresa', state.AppActiveUser.idEmpresa);

        axios.post("/RastrearVeiculosCliente", params, {              
                credentials: 'include',
                responseEncoding: 'iso88591',
                withCredentials: true } )
          .then((response) => {
            if (!response.data.hasOwnProperty("codigo") || response.data.codigo !== "99" ) {            
              commit('SET_VEICULOS', response.data)            
            }
            resolve(response);
          })
          .catch((error) => { reject(error) })
      })
    },
    fetchUltimosAvisos({ commit, state }) {
      return new Promise((resolve, reject) => {
        const params = new URLSearchParams();
        params.append('outputFormat', 'JSON');
        params.append('idCliente', state.AppActiveUser.id);
        params.append('idEmpresa', state.AppActiveUser.idEmpresa);
  
        axios.post("/ListarUltimosAvisosVeiculos", params, {              
                credentials: 'include',
                responseEncoding: 'iso88591',
                withCredentials: true } )
          .then((response) => {
            if (!response.data.hasOwnProperty("codigo") || response.data.codigo !== "99" ) {            
              commit('SET_ULTIMOS_AVISOS', response.data)
            }
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    fetchCorLocalidade({ commit, state }) {
      return new Promise((resolve, reject) => {
        const params = new URLSearchParams();
        params.append('method', 'FindAll');
        params.append('orderDirection', 'ASC');
        params.append('outputFormat', 'JSON');
        params.append('idCliente', state.AppActiveUser.id);
        params.append('idEmpresa', state.AppActiveUser.idEmpresa);
  
        axios.post("/CorLocalidadeRestServlet", params, {              
                credentials: 'include',
                responseEncoding: 'iso88591',
                withCredentials: true } )
          .then((response) => {
            if (!response.data.hasOwnProperty("codigo") || response.data.codigo !== "99" ) {            
              commit('SET_COR_LOCALIDADE', response.data)
            }
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    fetchListaDivisao({ commit, state }) {
      return new Promise((resolve, reject) => {
        const params = new URLSearchParams();
        params.append('method', 'FindAll');
        params.append('orderDirection', 'ASC');
        params.append('outputFormat', 'JSON');
        params.append('idCliente', state.AppActiveUser.id);
        params.append('idEmpresa', state.AppActiveUser.idEmpresa);
  
        axios.post("/DivisaoVeiculosRestServlet", params, {              
                credentials: 'include',
                responseEncoding: 'iso88591',
                withCredentials: true } )
          .then((response) => {
            if (!response.data.hasOwnProperty("codigo") || response.data.codigo !== "99" ) {            
              commit('SET_LISTA_DIVISAO', response.data)
            }
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },  
    fetchConfiguracaoSomAviso({ commit, state }) {
      return new Promise((resolve, reject) => {     
          const params = new URLSearchParams();      
          params.append('idCliente', state.AppActiveUser.id);  
          params.append('idEmpresa', state.AppActiveUser.idEmpresa); 
          params.append('pagina', -1);
        
          axios.post("/rest/SomAviso/Listar", params, {              
                  credentials: 'include',
                  responseEncoding: 'iso88591',
                  withCredentials: true } )
          .then((response) => {
              if (!response.data.hasOwnProperty("codigo") || response.data.codigo !== "99" ) {        
                  if (response.data.Resultado.quantidade > 1) {
                      commit('SET_LISTA_CONFIGURACAO_SOM_AVISO', response.data.Resultado.lista.item)                      
                  } else if (response.data.Resultado.quantidade === 1) {
                      let listaSomAviso = [];
                      listaSomAviso.push(response.data.Resultado.lista.item);
                      commit('SET_LISTA_CONFIGURACAO_SOM_AVISO', listaSomAviso);
                  } else {                      
                      commit('SET_LISTA_CONFIGURACAO_SOM_AVISO', []);
                  }
              }
              resolve(response);
          })
          .catch((error) => { reject(error) })                           
        })
    },      
    marcarAvisoDismissed({ commit }, aviso) {
      commit('MARCAR_AVISO_DISMISSED', aviso)
    }, 
    incluirListaPedidosParaRoteirizar({ commit }, pLista) {
      commit('INCLUIR_PEDIDOS_PARA_ROTEIRIZAR', pLista)
    },
    limparListaPedidosParaRoteirizar({ commit }) {
      commit('LIMPAR_LISTA_PEDIDOS_PARA_ROTEIRIZAR')
    },
    incluirListaPoisParaRoteirizar({ commit }, pLista) {
      commit('INCLUIR_PEDIDOS_PARA_ROTEIRIZAR', pLista)
    },
    limparListaPoisParaRoteirizar({ commit }) {
      commit('LIMPAR_LISTA_POI_PARA_ROTEIRIZAR')
    },
    limparDadosSessao({ commit }) {
      commit('LIMPAR_LISTA_VEICULOS')
      commit('LIMPAR_ULTIMOS_AVISOS')
      commit('LIMPAR_COR_LOCALIDADE')
      commit('LIMPAR_LISTA_DIVISAO')
      commit('LIMPAR_LISTA_PEDIDOS_PARA_ROTEIRIZAR')      
      commit('LIMPAR_LISTA_POI_PARA_ROTEIRIZAR')
    },
    // /////////////////////////////////////////////
    // COMPONENTS
    // /////////////////////////////////////////////

    // Vertical NavMenu
    updateVerticalNavMenuWidth({ commit }, width) {
      commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
    },

    // /////////////////////////////////////////////
    // UI
    // /////////////////////////////////////////////

    toggleContentOverlay({ commit }) {
      commit('TOGGLE_CONTENT_OVERLAY')
    },
    updateTheme({ commit }, val) {
      commit('UPDATE_THEME', val)
    },

    // /////////////////////////////////////////////
    // User/Account
    // /////////////////////////////////////////////

    updateUserInfo({ commit }, payload) {
      commit('UPDATE_USER_INFO', payload)
    },
    updateUserRole({ dispatch }, payload) {
      // Change client side
      payload.aclChangeRole(payload.userRole)

      // Make API call to server for changing role

      // Change userInfo in localStorage and store
      dispatch('updateUserInfo', {userRole: payload.userRole})
    },

    updateNomeCentral({ commit }, payload) {
      commit('UPDATE_NOME_CENTRAL', payload)
    },
    setarFiltro({ commit }, payload) {
      commit('SET_FILTRO', payload)
    },
    setExibirMensagemVeiculoDesatualizado({ commit }) {
      commit('SET_EXIBIR_MENSAGEM_VEICULO_DESATUALIZADO', true);
    },
    setNaoExibirMensagemVeiculoDesatualizado({ commit }) {
      commit('SET_EXIBIR_MENSAGEM_VEICULO_DESATUALIZADO', false);
    },
    setConfigColunasGrid({ commit }, payload) {
      commit('SET_CONFIG_COLUNAS_GRID', payload)
    },
    setConfigColunasGridMapa({ commit }, payload) {
      commit('SET_CONFIG_COLUNAS_GRID_MAPA', payload)
    },
    setConfigColunasDashboardTelemetria({ commit }, payload) {
      commit('SET_CONFIG_COLUNAS_DASHBOARD_TELEMETRIA', payload)
    },
    setConfigMapa({ commit }, payload) {
      commit('SET_CONFIG_MAPA', payload);      
    },
    setMenuFrotaConfigCards({ commit }, payload ) {
      commit('SET_MENU_FROTAS_CONFIG_CARDS', payload)
    }

}

export default actions
